import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { CambioRegistroInterface, FlujoTramiteResponse, PreviewCambioRegistroRequest } from '../components/ver-proyecto/interface/cambio-registro.interface';
import { Observable } from 'rxjs';
import { RpReq } from '../../registro-profesionales/interfaces/tipos';

const apiVucUrl = environment.apiVucUrl;
@Injectable({providedIn: 'root'})
export class CambioRegistroService {
    constructor(private http: HttpClient) { }

    previewTramitesRegistro(idTramiteViejo: string): Observable<FlujoTramiteResponse[]>{
        const body = {idTramiteViejo};
        return this.http.post<FlujoTramiteResponse[]>(`${apiVucUrl}api/v1.0/registro-profesionales/tramites-registro`, body);
    }

    procesarCambioRegistro(cambioRegistro: CambioRegistroInterface): Observable<boolean>{
        return this.http.post<boolean>(`${apiVucUrl}api/v1.0/registro-profesionales/actualizar-registro`, cambioRegistro)
    }

    personaTieneMigracion(numDocumento: string, profesion: string): Observable<boolean>{
        return this.http.post<boolean>(`${apiVucUrl}api/v1.0/registro-profesionales/tiene-migracion`, {numDocumento, profesion}, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }
}